
import CoursesDetailsHome from '../../components/CoursesDetailsHome';

const CoursesDetails = () => {
  return (
    <div >
      <CoursesDetailsHome />
  
    </div>
  );
};

export default CoursesDetails;
